import { createFeatureSelector, createSelector } from "@ngrx/store";
import { IUserInfoCognito } from "src/app/shared/services/cognito.service";

export const selectUserInfo = createFeatureSelector<IUserInfoCognito>('userInfo');
